/**
 * How To Use:
 * ==================================================
 * In your other JS files simply import by:
 * import Breakpoints from "helpers/breakpoints";
 *
 * Then, you can use it to pull the min and max breakpoint values based on the breakpoint i.e.
 * let b = new Breakpoints();
 * let desktopMin = b.getMin('desktop');
 * let desktopMax = b.getMax('desktop');
 *
 * or get a single breakpoint object
 * let aBreakpoint = b.getBreakpoint('desktop');
 *
 * or get all the known breakpoints we use
 * let allBreakpoints = b.getBreakpoints();
 *
 * @returns {{getBreakpoints: getBreakpoints, getBreakpoint: getBreakpoint, getMin: getMin, getMax: getMax}}
 *
 * Note: Edits to these values need to be reflected (for consistency) in:
 * core/helpers/BreakpointsHelper.php
 * development/styles/lib/_breakpoint.scss
 *
 */

export default function () {
    let mobilePortraitMinWidth = 0;
    let mobilePortraitMaxWidth = 479;

    let mobileLandscapeMinWidth = 0;
    let mobileLandscapeMaxWidth = 767;

    let tabletPortraitMinWidth = mobileLandscapeMaxWidth + 1;
    let tabletPortraitMaxWidth = 1023;

    let tabletLandscapeMinWidth = tabletPortraitMaxWidth + 1;
    let tabletLandscapeMaxWidth = 1439;

    let desktopMinWidth = tabletLandscapeMaxWidth + 1;
    let desktopMaxWidth = 1919;

    let desktopWideMinWidth = desktopMaxWidth + 1;
    let desktopWideMaxWidth = 9999;

    let globalNavTabletPortraitMin = mobileLandscapeMaxWidth + 1;
    let globalNavTabletPortraitMax = 1120;

    let _breakpoints = {
        mobilePortrait: {
            min: mobilePortraitMinWidth,
            max: mobilePortraitMaxWidth
        },
        mobileLandscape: {
            min: mobileLandscapeMinWidth,
            max: mobileLandscapeMaxWidth
        },
        tabletPortrait: {
            min: tabletPortraitMinWidth,
            max: tabletPortraitMaxWidth
        },
        tabletLandscape: {
            min: tabletLandscapeMinWidth,
            max: tabletLandscapeMaxWidth
        },
        desktop: {
            min: desktopMinWidth,
            max: desktopMaxWidth
        },
        desktopWide: {
            min: desktopWideMinWidth,
            max: desktopWideMaxWidth
        },
        globalNavTabletPortrait: {
            min: globalNavTabletPortraitMin,
            max: globalNavTabletPortraitMax
        }
    };

    let _bpExists = function (breakpoint) {
        let exists = _breakpoints.hasOwnProperty(breakpoint);
        if (!exists) {
            console.error(
                "The breakpoint '" + breakpoint + "' does not exist. Please check your spelling."
            );
        }
        return exists;
    };

    let getBreakpoints = function () {
        return _breakpoints;
    };

    let getBreakpoint = function (breakpoint) {
        if (_bpExists(breakpoint)) {
            return _breakpoints[breakpoint];
        } else {
            return {};
        }
    };

    let getMin = function (breakpoint) {
        if (_bpExists(breakpoint)) {
            return _breakpoints[breakpoint].min;
        } else {
            return 0;
        }
    };

    let getMax = function (breakpoint) {
        if (_bpExists(breakpoint)) {
            return _breakpoints[breakpoint].max;
        } else {
            return 0;
        }
    };

    let isDesktopWide = function () {
        const currentWindowWidth = window.innerWidth;
        return (
            currentWindowWidth >= _breakpoints['desktopWide'].min &&
            currentWindowWidth <= _breakpoints['desktopWide'].max
        );
    };

    let isDesktop = function () {
        const currentWindowWidth = window.innerWidth;
        return (
            currentWindowWidth >= _breakpoints['desktop'].min &&
            currentWindowWidth <= _breakpoints['desktop'].max
        );
    };

    let isTabletLandscape = function () {
        const currentWindowWidth = window.innerWidth;
        return (
            currentWindowWidth >= _breakpoints['tabletLandscape'].min &&
            currentWindowWidth <= _breakpoints['tabletLandscape'].max
        );
    };

    let isTabletPortrait = function () {
        const currentWindowWidth = window.innerWidth;
        return (
            currentWindowWidth >= _breakpoints['tabletPortrait'].min &&
            currentWindowWidth <= _breakpoints['tabletPortrait'].max
        );
    };

    let isMobileLandscape = function () {
        const currentWindowWidth = window.innerWidth;
        return (
            currentWindowWidth > _breakpoints['mobilePortrait'].max &&
            currentWindowWidth >= _breakpoints['mobileLandscape'].min &&
            currentWindowWidth <= _breakpoints['mobileLandscape'].max
        );
    };

    let isMobilePortrait = function () {
        const currentWindowWidth = window.innerWidth;
        return (
            currentWindowWidth >= _breakpoints['mobilePortrait'].min &&
            currentWindowWidth <= _breakpoints['mobilePortrait'].max
        );
    };

    let getCurrentBreakpointName = function () {
        if (this.isDesktopWide()) {
            return 'desktopWide';
        } else if (this.isDesktop()) {
            return 'desktop';
        } else if (this.isTabletLandscape()) {
            return 'tabletLandscape';
        } else if (this.isTabletPortrait()) {
            return 'tabletPortrait';
        } else if (this.isMobileLandscape()) {
            return 'mobileLandscape';
        } else if (this.isMobilePortrait()) {
            return 'mobilePortrait';
        }
    };

    return {
        getBreakpoints: getBreakpoints,
        getBreakpoint: getBreakpoint,
        getMin: getMin,
        getMax: getMax,

        isDesktopWide: isDesktopWide,
        isDesktop: isDesktop,
        isTabletLandscape: isTabletLandscape,
        isTabletPortrait: isTabletPortrait,
        isMobileLandscape: isMobileLandscape,
        isMobilePortrait: isMobilePortrait,

        getCurrentBreakpointName: getCurrentBreakpointName
    };
}
